module.exports = __webpack_public_path__ + "img/banner_icon_3.6f5d90c4.jpg";